// Shop-Texte: Seite Shop + Galerie „das Spiel in echt“.
// Übersetzung von fr/shop.js — exakt dieselben Schlüssel.
// Die Produkttexte (name, description, features der Packs) stehen hier NICHT:
// sie kommen über tp()/tpList() aus der Datenbank (siehe LanguageContext).
export default {
  'shop.seo.titre': 'Shop - Gender-Reveal-Puzzles',
  'shop.seo.description':
    "Zwei Joyful-Reveal-Packs für die Gender-Reveal-Feier mit der Familie. Versand nach Deutschland, Belgien, Frankreich, Luxemburg, Niederlande und Spanien.",

  'shop.page.chargement': 'Der Shop wird geladen...',

  // Strukturierte Daten schema.org (CollectionPage) im <head>.
  'shop.schema.nom': 'Mirum Games Shop',
  'shop.schema.description': 'Entdecken Sie alle unsere Joyful Reveal Packs',

  'shop.entete.badge': '🛍️ Unser Shop',
  'shop.entete.titre': 'Joyful Reveal - Bärchen',
  'shop.entete.texte':
    'Wählen Sie das perfekte Pack für Ihren magischen Moment. Jedes Puzzle ist eine besondere Kreation für Ihre Familie.',

  // Entscheidungshilfe: Der Satz ist zerlegt, weil „Essentiel“ und „Premium“
  // im JSX zwischen <strong> stehen. seg1+seg2+seg3+seg4+seg5 = der ganze
  // Satz; das JSX fügt KEIN Leerzeichen ein, die Leerzeichen am Anfang und am
  // Ende der Segmente zählen also mit.
  'shop.aide.titre': 'Zwei Packs, ein einziges Spiel',
  'shop.aide.seg1': 'Das Pack ',
  'shop.aide.seg2': 'Essentiel',
  'shop.aide.seg3': ', wenn Sie Ihre Fragen und Ihre Teams selbst vorbereiten. Das Pack ',
  'shop.aide.seg4': 'Premium',
  'shop.aide.seg5':
    ', wenn alles schon fertig bei Ihnen ankommen soll: die Stoffbeutel, der gedruckte Fragebogen und der Erinnerungsumschlag.',

  // Rückfall für Produkte: nur wenn die Datenbank weder description noch
  // features liefert (sollte nicht vorkommen) — das sind keine packs.*-Schlüssel.
  'shop.produit.descriptionRepli':
    'Entdecken Sie dieses Joyful Reveal Pack für eine unvergessliche Gender Reveal Party!',
  'shop.produit.repliDuo1': '2 Spielboxen',
  'shop.produit.repliDuo2': 'Vorteilspack',
  'shop.produit.repliDuo3': 'Ideal für 2 Feste',
  'shop.produit.repliFamille1': '3 komplette Kits',
  'shop.produit.repliFamille2': 'Bestes Preis-Leistungs-Verhältnis',
  'shop.produit.repliFamille3': 'Ideal für große Familien',
  'shop.produit.repliPremium1': 'Komplettes Spiel',
  'shop.produit.repliPremium2': 'Zubehör inklusive',
  'shop.produit.repliPremium3': 'Premiumqualität',
  'shop.produit.repliMixte1': 'Version Mädchen + Junge',
  'shop.produit.repliMixte2': 'Ideal für Zwillinge',
  'shop.produit.repliMixte3': 'Komplettes Pack',
  'shop.produit.repliDefaut1': 'Gender-Reveal-Spielbox',
  'shop.produit.repliDefaut2': 'Handwerklich gefertigt',
  'shop.produit.repliDefaut3': 'Schneller Versand',

  // Name des Artikels, so wie er in den Warenkorb kommt.
  'shop.panier.nomArticle': 'Joyful Reveal - Bärchen - {nom}',
  'shop.panier.suffixeGarcon': ' (Junge)',
  'shop.panier.suffixeFille': ' (Mädchen)',

  'shop.grille.altPhoto': '{nom} — Joyful Reveal, Gender-Reveal-Spiel, Produktfoto',
  'shop.grille.rupture': '❌ AUSVERKAUFT',
  'shop.grille.bientotRetour': 'Bald wieder verfügbar',
  'shop.grille.enStock': 'Auf Lager',
  'shop.grille.voirPlus': 'Mehr anzeigen',
  'shop.grille.autresCaracteristiques': '+{n} weitere',
  'shop.grille.epuise': 'Ausverkauft',
  'shop.grille.ajoute': '✓ Hinzugefügt!',
  'shop.grille.ajouter': '🛒 Hinzufügen',
  'shop.grille.versPanier': '→ Warenkorb',
  'shop.grille.ficheComplete': '📋 Zur vollständigen Produktseite',

  'shop.vide.titre': 'Kein Pack gefunden',
  'shop.vide.texte': 'Probieren Sie einen anderen Filter',

  'shop.pourquoi.titre': 'Warum Joyful Reveal wählen?',
  'shop.pourquoi.emballageTitre': 'Premium-Verpackung',
  'shop.pourquoi.emballageTexte':
    'Jedes Puzzle kommt in einer eleganten Geschenkverpackung — bereit zum Verschenken oder zum gemeinsamen Öffnen.',
  'shop.pourquoi.jeuTitre': 'Interaktives Spiel',
  'shop.pourquoi.jeuTexte':
    'Ein einzigartiges Konzept, das die Enthüllung in einen Spielmoment verwandelt, bei dem alle mitmachen — mit lustigen Fragen und Antworten.',
  'shop.pourquoi.assemblageTitre': 'Leicht zusammenzusetzen',
  'shop.pourquoi.assemblageTexte':
    'Ein Puzzle, das Sie während des Frage-und-Antwort-Spiels ganz leicht gemeinsam mit der Familie zusammensetzen.',
  'shop.pourquoi.momentTitre': 'Magischer Moment',
  'shop.pourquoi.momentTexte':
    'Schaffen Sie eine unvergessliche Erinnerung, indem Sie das Geschlecht des Babys gemeinsam mit der Familie enthüllen.',
  'shop.pourquoi.expeditionTitre': 'Versand aus Belgien',
  'shop.pourquoi.expeditionTexte':
    'Versand innerhalb von 1 bis 2 Werktagen nach Deutschland, Belgien, Frankreich und Luxemburg. Verstärkte Verpackung.',
  'shop.pourquoi.retractationTitre': '14 Tage Bedenkzeit',
  'shop.pourquoi.retractationTexte':
    'Widerrufsrecht von 14 Tagen ab Erhalt, wie es das europäische Recht für Online-Käufe vorsieht.',

  'shop.cta.titre': 'Bereit für die magische Enthüllung?',
  'shop.cta.texte': 'Wählen Sie Ihr Pack und schaffen Sie einen unvergesslichen Moment mit Ihrer Familie',
  'shop.cta.bouton': '🛒 Packs entdecken',

  'shop.modale.titre': 'Das ist für...',
  'shop.modale.sousTitre': 'Wählen Sie das Geschlecht für Ihr Puzzle',
  'shop.modale.garcon': 'Junge',
  'shop.modale.fille': 'Mädchen',
  'shop.modale.annuler': 'Abbrechen',

  'shop.galerie.titre': 'Das Spiel in echt',
  'shop.galerie.sousTitre':
    'Fotos des Produkts, genau so, wie Sie es erhalten — keine bösen Überraschungen.',
  'shop.galerie.agrandir': 'Foto vergrößern: {titre}',
  'shop.galerie.fermer': 'Schließen',
  'shop.galerie.boiteRectoTitre': 'Die Box',
  'shop.galerie.boiteRectoLegende': 'Das Spiel Joyful Reveal, bereit zum Verschenken.',
  'shop.galerie.boiteRectoAlt':
    'Box des Spiels Joyful Reveal: zwei Bärchen, Puzzleteil zum Freirubbeln „GIRL oder BOY?“',
  'shop.galerie.contenuTitre': 'Was Sie erhalten',
  'shop.galerie.contenuLegende':
    'Die Box, der Fragebogen als Erinnerung und die beiden Team-Stoffbeutel.',
  'shop.galerie.contenuAlt':
    'Vollständiger Inhalt des Spiels Joyful Reveal: die Box, der Fragebogen als Erinnerung und die beiden Stoffbeutel',
  'shop.galerie.pochonsTitre': 'Die beiden Teams',
  'shop.galerie.pochonsLegende': 'Zwei Stoffbeutel für Team 1 und Team 2.',
  'shop.galerie.pochonsAlt':
    'Die beiden Stoffbeutel des Spiels, beschriftet mit Team 1 und Team 2, mit Bärchen verziert',
  'shop.galerie.boiteVersoTitre': 'So wird gespielt',
  'shop.galerie.boiteVersoLegende': 'Die 4 Schritte des Spiels, 2 bis 10 Spieler, etwa 20 Minuten.',
  'shop.galerie.boiteVersoAlt':
    'Rückseite der Box Joyful Reveal mit den 4 Schritten des Spiels, für 2 bis 10 Spieler, 20 Minuten',
};
